import { Home } from "../pages";

// navType { hideHeader, hideFooter }
const RouterList = [
  {
    path: "/",
    name: "home",
    component: Home,
  },
];
export default RouterList;
